import IndicatorLine from '@/domain/scene/indicators/generic/IndicatorLine.js'

const NAME = 'ObserverTopIndicatorLine'
const LENGTH_REL = 0.090
const INIT_X_REL = 0
const INIT_Y_REL = -0.080
const DRAW_UP = true

export default class ObserverTopIndicatorLine extends IndicatorLine {
  constructor () {
    super(
      NAME,
      LENGTH_REL,
      INIT_X_REL,
      INIT_Y_REL,
      DRAW_UP
    )
  }
}
